import routes from "./routes";
import axios from "axios";
import { detectTouch } from "../service/detect-touch";

axios.interceptors.request.use(function (config) {
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  return config;
});

const block = document.getElementById("app");

let loading = true;
let currentRoute = resolveRoute(window.location.pathname);
console.log(currentRoute);

if (!currentRoute) throw new Error("undefined location");

function resolveRoute(needlePath) {
  let route = null;
  const locationParts = needlePath.split("/");
  Object.keys(routes).some((path) => {
    const parts = path.split("/");
    for (let i = 0; i < parts.length; i++) {
      if (typeof locationParts[i] === "undefined") return false;
      if (!parts[i].length && !locationParts[i].length) continue;
      if (parts[i][0] === ":") continue;
      if (parts[i] !== locationParts[i]) return false;
    }
    route = routes[path];
    return true;
  });
  return route;
}

function loaded() {
  loading = false;
}

function writeState() {
  history.replaceState(
    {
      content: block.innerHTML,
      class: document.body.getAttribute("class"),
      title: document.title
    },
    document.title,
    window.location.href
  );
}

function loadContent(url) {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function registerListeners() {
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a.routerLink");
    if (!link) return;
    e.preventDefault();
    goToRoute(link.getAttribute("href"));
  });

  window.addEventListener("popstate", (e) => {
    if (loading) {
      currentRoute.breakAction();
    }
    loading = true;

    currentRoute
      .exitAction(document.location.pathname)
      .then(() => {
        document.body.className = e.state.class;
        document.title = e.state.title;
        block.innerHTML = e.state.content;
        currentRoute = routes[document.location.pathname];
        return currentRoute.enterAction();
      })
      .then(loaded);
  });
}

function goToRoute(href) {
  if (loading) return;

  loading = true;
  Promise.all([loadContent(href), currentRoute.exitAction(href)])
    .then(([data]) => {
      const parser = document.createElement("a");
      parser.href = href;
      currentRoute = resolveRoute(parser.pathname);

      document.body.className = data.class;
      document.title = data.title;
      block.innerHTML = data.content;
      history.pushState(
        {
          content: data.content,
          class: data.class,
          title: data.title
        },
        document.title,
        href
      );
      if (detectTouch()) {
        document.body.classList.add("body_touch");
      } else {
        document.body.classList.add("body_no-touch");
      }
      return currentRoute.enterAction();
    })
    .catch((err) => {
      console.error(err);
      currentRoute.breakAction();
      return currentRoute.enterAction();
    })
    .then(loaded);
}

export const route = goToRoute;

export default () => {
  writeState();
  registerListeners();
  currentRoute.enterAction().then(loaded);
};
